import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './PullQuote.css';

function PullQuote({ backgroundImage }) {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.3 });

  return (
    <div className="pull-quote" ref={ref}>
      {backgroundImage && (
        <div className="pull-quote-bg">
          <img src={backgroundImage} alt="" loading="lazy" />
        </div>
      )}
      <div className="pull-quote-overlay" />
      <motion.div
        className="pull-quote-content"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={inView ? { opacity: 1, scale: 1 } : {}}
        transition={{ duration: 0.8, ease: [0.4, 0, 0.2, 1] }}
      >
        <img src="/logo-official.png" alt="Casa Primas" className="pull-quote-logo" />
        <span className="pull-quote-brand">Casa Primas</span>
      </motion.div>
    </div>
  );
}

export default PullQuote;
